export const GLOSSARY_ABBREVIATIONS_QUERY = `GlossaryAbbreviations {
    glossaryAbbreviations(pagination: { page: 1, pageSize: 100 }) {
        data {
            id
            attributes {
                short_form
                full_form
                program
                seq_id
            }
        }
    }
}`;

export const GLOSSARY_TERMS_QUERY = `GlossaryTerms {
    glossaryTerms(pagination: { page: 1, pageSize: 100 }) {
        data {
            id
            attributes {
                title
                definition
                program
                seq_id
            }
        }
    }
}`;
